import { backendUri } from "@/utils/settings";
import { PCGApi } from "../services/pcg";

const getPokedexInfoQuery = async (queryClient, pokemonId) => {
  return await queryClient.fetchQuery(
    backendUri + "api/game/ext/trainer/pokedex/info/?pokedex_id=" + pokemonId,
    async () => await PCGApi.Trainer.getPokedexInfo(pokemonId),
    {
      staleTime: 1000 * 60 * 10,
      refetchOnWindowFocus: false,
    }
  );
};

export { getPokedexInfoQuery };
